import { otaUpdatesUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

export const startInstallationProcess = async (
  namespace: string,
  update_id: string,
) => {
  const url = otaUpdatesUrlEnvVar();
  const headers = {
    ...buildAxiosAuthenticationHeaders(),
  };

  try {
    const response = await axios.post(
      `${url}/api/v2/ns/${namespace}/installation-process/${update_id}/start`,
      {},
      {
        headers: headers,
      },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      const message =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        "Failed to start the installation process. Please try again later.";

      throw new Error(message);
    } else {
      throw new Error(
        "An unexpected error occurred while starting the installation process.",
      );
    }
  }
};
